import React, { Component } from "react";

import { Formik, Form } from "formik";
import { CheckboxInput } from "../../../../forms/components";

import { editGateway } from "../../../../libs/functions";
import Util from "../../../../libs/util";

import Swal from "sweetalert2";
import { has } from "lodash";

class ManageMerchantGateway extends Component {
	constructor(props) {
		super(props);

		this.state = {};

		const initialValues = Object.keys(props.gateway).reduce((result, key) => {
			if (!result[key]) result[key] = {};
			for (let type in props.MDRTypes) {
				result[key][type] = false;
			}
			return result;
		}, {});

		for (let type in props.accepted) {
			let accept = props.accepted[type];
			for (let gateway of accept) {
				if (has(initialValues, [gateway, type]))
					initialValues[gateway][type] = true;
			}
		}

		this.state.initialValues = initialValues;

		this.editModalRef = React.createRef();
	}

	componentDidUpdate = (prevProps) => {
		if (
			JSON.stringify(prevProps.accepted) !== JSON.stringify(this.props.accepted)
		) {
			const initialValues = Object.keys(this.props.gateway).reduce(
				(result, key) => {
					if (!result[key]) result[key] = {};
					for (let type in this.props.MDRTypes) {
						if (has(result, [key, type])) result[key][type] = false;
					}
					return result;
				},
				{}
			);

			for (let type in this.props.accepted) {
				let accept = this.props.accepted[type];
				for (let gateway of accept) {
					if (has(initialValues, [gateway, type]))
						initialValues[gateway][type] = true;
				}
			}

			this.setState({ initialValues: initialValues });
		}
	};

	_editGateway = (values, { setSubmitting, resetForm }) => {
		Swal.fire({
			title: "Editing Payment Gateway",
			allowOutsideClick: () => !Swal.isLoading(),
			onBeforeOpen: async () => {
				await Util.hideModal("edit-gateway");
			},
			onOpen: async () => {
				try {
					let status = await editGateway({
						id: this.props.merchant.id,
						accepted: values,
					});
					Swal.hideLoading();
					setSubmitting(false);

					if (status) {
						Swal.fire({
							icon: "success",
							title: "Payment Gateway Edited",
						}).then(async () => {
							this.props.retrieveMerchants(true);
							resetForm();
						});
					} else {
						Swal.fire({
							icon: "error",
							title: "Unable to Edit Payment Gateway",
						});
					}
				} catch (err) {
					setSubmitting(false);
					if (err.response.status === 401) {
						Util.expireSession().then(() => {
							window.location = "/login";
						});
					} else {
						Swal.fire({
							icon: "error",
							title: `Unable to Edit Payment Gateway`,
							onClose: () => {},
						});
					}
				}
			},
		});
	};

	render() {
		const { readOnly, MDRTypes, gateway, accepted } = this.props;
		const { initialValues } = this.state;
		return (
			<div className="uk-margin-bottom">
				<h4 className="uk-margin-remove">
					<span className="uk-flex uk-flex-middle">
						<i
							className="uk-margin-small-right form-header-icon"
							uk-icon="icon: fa-solid-door-open; ratio: 0.9"
						/>
						Payment Gateway
						{!readOnly && (
							<button
								className="uk-margin-small-left uk-icon-button uk-button-primary"
								uk-icon="icon: fa-solid-pencil-alt; ratio: 0.5"
								type="button"
								onClick={() => Util.showModal("edit-gateway")}
							/>
						)}
					</span>
					<hr className="uk-margin-small-top uk-margin-small-bottom" />
				</h4>
				<div className="view-gateway-table uk-padding-small uk-padding-remove-vertical">
					<table className="uk-table uk-table-striped uk-table-middle">
						<thead>
							<tr>
								<th className="uk-text-center">Gateway</th>
								<th>Accepted Payment Type</th>
							</tr>
						</thead>
						<tbody>
							{Object.keys(gateway).map((key) => (
								<tr key={key}>
									<td className="uk-text-center">
										<img
											className="uk-img"
											src={`data:image/*;base64,${gateway[key].image}`}
											width="50"
										/>
										{/* <span className="uk-margin-left">{gateway[key].name}</span> */}
									</td>
									<td>
										<div className="uk-flex uk-flex-between uk-flex-left@s uk-flex-wrap">
											{Object.keys(MDRTypes).map((type, index) => {
												if (
													accepted[type] &&
													accepted[type].includes(key) &&
													MDRTypes[type]?.isAdhoc !== true &&
													MDRTypes[type]?.ipp !== true
												)
													return (
														<div className={"uk-margin-left"} key={index}>
															<label key={type} className="uk-form-label">
																<input
																	className="uk-checkbox uk-margin-right"
																	name={`accepted.${key}.${type}`}
																	type="checkbox"
																	checked={true}
																	readOnly
																/>
																{MDRTypes[type].label}
															</label>
														</div>
													);
											})}
										</div>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
				<div
					id="edit-gateway"
					className="uk-modal-container"
					uk-modal="stack: true"
					ref={this.editModalRef}
				>
					<div className="uk-modal-dialog uk-modal-body">
						<h2 className="uk-modal-title">Edit Payment Gateway</h2>
						<Formik
							initialValues={initialValues}
							enableReinitialize={true}
							onSubmit={this._editGateway}
						>
							<Form className="uk-form-stacked">
								<table className="uk-table uk-table-striped uk-table-middle">
									<thead>
										<tr>
											<th className="uk-text-center">Gateway</th>
											<th>Accepted Payment Type</th>
										</tr>
									</thead>
									<tbody>
										{Object.keys(gateway).map((key) => (
											<tr key={key}>
												<td className="uk-text-center">
													<img
														className="uk-img"
														src={`data:image/*;base64,${gateway[key].image}`}
														width="50"
														height="auto"
													/>
													{/* <span className="uk-margin-left">{gateway[key].name}</span> */}
												</td>
												<td>
													<div className="uk-child-width-1-4 uk-grid-collapse uk-grid">
														{Object.keys(MDRTypes).map((type) => {
															if (
																MDRTypes[type]?.isAdhoc !== true &&
																MDRTypes[type]?.ipp !== true
															)
																return (
																	<CheckboxInput
																		key={type}
																		noMargin={true}
																		label={MDRTypes[type].label}
																		name={`${key}.${type}`}
																	/>
																);
														})}
													</div>
												</td>
											</tr>
										))}
									</tbody>
								</table>
								<p className="uk-text-right">
									<button
										className="uk-button uk-button-default uk-modal-close"
										type="button"
									>
										Cancel
									</button>
									<button className="uk-button uk-button-primary" type="submit">
										Edit
									</button>
								</p>
							</Form>
						</Formik>
					</div>
				</div>
			</div>
		);
	}
}

export default ManageMerchantGateway;
